export const PRODUCT_MAPPINGS_LOADED = 'PRODUCT_MAPPINGS_LOADED'
export const PRODUCT_MAPPING_UPDATED = 'PRODUCT_MAPPING_UPDATED'
